import { combineReducers } from '@reduxjs/toolkit';
import { api } from './api';
import { authSlice } from './slice';

export const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  auth: authSlice.reducer,
});
